declare global {
  interface Window {
    __APP_CONFIG__?: {
      apiBaseUrl?: string;
    };
  }
}

// Automatically use Docker config in production, Vite env in dev
// Check if window exists (won't exist during build/SSR)
const runtimeApiBase =
  (typeof window !== 'undefined' ? window.__APP_CONFIG__?.apiBaseUrl : undefined) 
  ?? (import.meta.env.DEV ? '/router' : import.meta.env?.VITE_ROUTER_URL)
  ?? '';

export const API_BASE_URL = runtimeApiBase;
